var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#FFC047"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.346 11V4.7H7.938C8.496 4.7 8.973 4.79 9.369 4.97C9.771 5.15 10.08 5.408 10.296 5.744C10.512 6.08 10.62 6.479 10.62 6.941C10.62 7.403 10.512 7.802 10.296 8.138C10.08 8.468 9.771 8.723 9.369 8.903C8.973 9.077 8.496 9.164 7.938 9.164H5.994L6.516 8.633V11H5.346ZM9.468 11L7.875 8.714H9.126L10.728 11H9.468ZM6.516 8.759L5.994 8.201H7.884C8.4 8.201 8.787 8.09 9.045 7.868C9.309 7.646 9.441 7.337 9.441 6.941C9.441 6.539 9.309 6.23 9.045 6.014C8.787 5.798 8.4 5.69 7.884 5.69H5.994L6.516 5.114V8.759Z",
    fill: "#F8F8F8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferee);
export default __webpack_public_path__ + "static/media/referee.b197ca732b976dbfef0a7da7ef11cbee.svg";
export { ForwardRef as ReactComponent };